import React from "react";

const Footer = () => {
  return (
    <footer className="site-footer-wrap">
      <div className="footer-wave-wrap">
        <svg
          viewBox="0 0 1200 100"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
          style={{ display: "block", width: "100%", height: "100px" }}
        >
          {/* Green base — full rectangle */}
          <rect x="0" y="0" width="1200" height="100" fill="#006A4E" />
          {/* Cream scallop — 3 rounded peaks cutting into green */}
          <path
            d="M0,0 L0,35 C100,58 200,82 300,62 C400,42 500,72 600,52 C700,32 800,68 900,48 C1000,28 1100,58 1200,40 L1200,0 Z"
            fill="#FAF7F2"
          />
          {/* Matcha line */}
          <path
            d="M0,37 C100,60 200,84 300,64 C400,44 500,74 600,54 C700,34 800,70 900,50 C1000,30 1100,60 1200,42"
            fill="none"
            stroke="#4CAF7D"
            strokeWidth="3.5"
            opacity="0.8"
          />
          {/* Red accent */}
          <path
            d="M0,42 C110,64 220,86 330,68 C450,48 560,76 670,58 C780,38 890,72 1000,54 C1080,40 1150,58 1200,48"
            fill="none"
            stroke="#D4213D"
            strokeWidth="2.5"
            opacity="0.6"
          />
          {/* Pale shimmer */}
          <path
            d="M0,31 C100,54 200,78 300,58 C400,38 500,68 600,48 C700,28 800,62 900,44 C1000,24 1100,52 1200,36"
            fill="none"
            stroke="#A8D5B5"
            strokeWidth="2"
            opacity="0.45"
          />
        </svg>
      </div>

      <div className="site-footer">
        <span className="footer-name">Farha Lina</span>
        <span className="footer-copy">© 2026 · All rights reserved</span>
        <nav className="footer-links">
          <a href="#about">About</a>
          <a href="#projects">Experience</a>
          <a href="#contact">Contact</a>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
